"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  generateEventId: () => generateEventId,
  generateRecurringValues: () => generateRecurringValues,
  getAllEvents: () => getAllEvents,
  getPrimaryCalendar: () => getPrimaryCalendar,
  getWeekday: () => getWeekday
});
module.exports = __toCommonJS(utils_exports);
var import_core = require("@hcengineering/core");
var import__ = __toESM(require("."));
function getInstance(event, date) {
  const diff = event.dueDate - event.date;
  return {
    ...event,
    recurringEventId: event.eventId,
    date,
    dueDate: date + diff,
    originalStartTime: date,
    _class: import__.default.class.ReccuringInstance,
    eventId: generateEventId(),
    _id: (0, import_core.generateId)(),
    virtual: true
  };
}
__name(getInstance, "getInstance");
function generateRecurringValues(rule, startDate, from, to) {
  const currentDate = new Date(startDate);
  switch (rule.freq) {
    case "DAILY":
      return generateDailyValues(rule, currentDate, from, to);
    case "WEEKLY":
      return generateWeeklyValues(rule, currentDate, from, to);
    case "MONTHLY":
      return generateMonthlyValues(rule, currentDate, from, to);
    case "YEARLY":
      return generateYearlyValues(rule, currentDate, from, to);
    default:
      throw new Error("Invalid recurring rule frequency");
  }
}
__name(generateRecurringValues, "generateRecurringValues");
function generateDailyValues(rule, currentDate, from, to) {
  const values = [];
  const { count, endDate, interval } = rule;
  const { bySetPos } = rule;
  let i = 0;
  while (true) {
    if (bySetPos == null || bySetPos.includes(getSetPos(currentDate))) {
      const res = currentDate.getTime();
      if (currentDate.getTime() > to) break;
      if (endDate != null && currentDate.getTime() > endDate) break;
      if (res >= from && res <= to) {
        values.push(res);
      }
      i++;
    }
    currentDate.setDate(currentDate.getDate() + (interval ?? 1));
    if (count !== void 0 && i === count) break;
  }
  return values;
}
__name(generateDailyValues, "generateDailyValues");
function generateWeeklyValues(rule, currentDate, from, to) {
  const values = [];
  const { count, endDate, interval } = rule;
  let { byDay, bySetPos } = rule;
  let i = 0;
  if (byDay === void 0) {
    byDay = [getWeekday(currentDate)];
  }
  while (true) {
    const next = new Date(currentDate).setDate(currentDate.getDate() + (interval ?? 1) * 7);
    const end = new Date(new Date(currentDate).setDate(currentDate.getDate() + 7));
    let date = currentDate;
    while (date < end) {
      if (endDate != null && date.getTime() > endDate) return values;
      if (date.getTime() > to) return values;
      if ((byDay == null || matchesByDay(date, byDay)) && (bySetPos == null || bySetPos.includes(getSetPos(date)))) {
        const res = date.getTime();
        if (res >= from && res <= to) {
          values.push(res);
        }
        i++;
      }
      date = new Date(date.setDate(date.getDate() + 1));
      if (count !== void 0 && i === count) return values;
    }
    currentDate = new Date(next);
  }
}
__name(generateWeeklyValues, "generateWeeklyValues");
function matchesByDay(date, byDay) {
  const weekday = getWeekday(date);
  const dayOfMonth = Math.floor((date.getDate() - 1) / 7) + 1;
  for (const byDayItem of byDay) {
    if (byDayItem === weekday) {
      return true;
    }
    const pos = parseInt(byDayItem);
    if (isNaN(pos)) continue;
    if (pos > 0 && dayOfMonth === pos) {
      return true;
    }
    if (pos < 0 && dayOfMonth === getNegativePosition(date, weekday, pos)) {
      return true;
    }
  }
  return false;
}
__name(matchesByDay, "matchesByDay");
function getNegativePosition(date, weekday, pos) {
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const occurrences = [];
  for (let day = lastDayOfMonth; day >= 1; day--) {
    const tempDate = new Date(date.getFullYear(), date.getMonth(), day);
    if (getWeekday(tempDate) === weekday) {
      occurrences.push(day);
    }
    if (occurrences.length === Math.abs(pos)) {
      return occurrences.pop();
    }
  }
  throw new Error(`Unable to calculate negative position ${pos}`);
}
__name(getNegativePosition, "getNegativePosition");
function generateMonthlyValues(rule, currentDate, from, to) {
  const values = [];
  const { count, endDate, interval } = rule;
  let { byDay, byMonthDay, bySetPos } = rule;
  let i = 0;
  if (byDay == null && byMonthDay == null) {
    byMonthDay = [currentDate.getDate()];
  }
  while (true) {
    const next = new Date(currentDate).setMonth(currentDate.getMonth() + (interval ?? 1), 1);
    const end = new Date(new Date(currentDate).setMonth(currentDate.getMonth() + 1, 1));
    let date = currentDate;
    const candidates = [];
    if (byDay == null && bySetPos == null && byMonthDay != null) {
      for (const day of byMonthDay) {
        const originalDate = new Date(currentDate.getTime());
        const sameDate = new Date(
          Date.UTC(
            currentDate.getUTCFullYear(),
            currentDate.getUTCMonth(),
            day,
            originalDate.getUTCHours(),
            originalDate.getUTCMinutes(),
            originalDate.getUTCSeconds(),
            originalDate.getUTCMilliseconds()
          )
        );
        if (sameDate.getUTCMonth() === currentDate.getUTCMonth()) {
          candidates.push(sameDate);
        }
      }
    } else {
      while (date < end) {
        if ((byDay == null || matchesByDay(date, byDay)) && (byMonthDay == null || byMonthDay.includes(date.getDate()))) {
          candidates.push(new Date(date));
        }
        date = new Date(date.setDate(date.getDate() + 1));
      }
    }
    let filtered = candidates;
    if (bySetPos != null) {
      filtered = bySetPos.map((pos) => {
        if (pos === 0) return null;
        const index = pos > 0 ? pos - 1 : candidates.length + pos;
        return candidates[index] ?? null;
      }).filter((d) => d != null);
    }
    for (const d of filtered) {
      const res = d.getTime();
      if (res >= from && res <= to) {
        values.push(res);
        i++;
        if (count !== void 0 && i === count) return values;
      }
    }
    if (endDate != null && next > endDate) return values;
    if (next >= to) return values;
    currentDate = new Date(next);
  }
}
__name(generateMonthlyValues, "generateMonthlyValues");
function generateYearlyValues(rule, currentDate, from, to) {
  const values = [];
  const { count, endDate, interval } = rule;
  const { byDay, byMonthDay, byYearDay, byWeekNo, byMonth, bySetPos } = rule;
  let i = 0;
  while (true) {
    const next = new Date(currentDate).setFullYear(currentDate.getFullYear() + (interval ?? 1), 0, 1);
    const end = new Date(new Date(currentDate).setFullYear(currentDate.getFullYear() + 1, 0, 1));
    let date = currentDate;
    const candidates = [];
    if (byDay == null && byMonthDay == null && byYearDay == null && byWeekNo == null && byMonth == null && bySetPos == null) {
      const originalDate = new Date(currentDate.getTime());
      const sameDate = new Date(
        Date.UTC(
          currentDate.getUTCFullYear(),
          originalDate.getUTCMonth(),
          originalDate.getUTCDate(),
          originalDate.getUTCHours(),
          originalDate.getUTCMinutes(),
          originalDate.getUTCSeconds(),
          originalDate.getUTCMilliseconds()
        )
      );
      candidates.push(sameDate);
    } else {
      while (date < end) {
        if ((byDay == null || matchesByDay(date, byDay)) && (byMonthDay == null || byMonthDay.includes(date.getDate())) && (byYearDay == null || byYearDay.includes(getYearDay(date))) && (byWeekNo == null || byWeekNo.includes(getWeekNumber(date))) && (byMonth == null || byMonth.includes(date.getMonth()))) {
          const res = date.getTime();
          if (res >= from && res <= to) {
            candidates.push(new Date(res));
          }
          i++;
        }
        date = new Date(date.setDate(date.getDate() + 1));
      }
    }
    let filtered = candidates;
    if (bySetPos != null) {
      filtered = bySetPos.map((pos) => {
        if (pos === 0) return null;
        const index = pos > 0 ? pos - 1 : candidates.length + pos;
        return candidates[index] ?? null;
      }).filter((d) => d != null);
    }
    for (const d of filtered) {
      const res = d.getTime();
      if (res >= from && res <= to) {
        values.push(res);
        i++;
        if (count !== void 0 && i === count) return values;
      }
    }
    if (endDate != null && next > endDate) return values;
    if (next >= to) return values;
    currentDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + (interval ?? 1)));
  }
}
__name(generateYearlyValues, "generateYearlyValues");
function getSetPos(date) {
  const month = date.getMonth();
  const year = date.getFullYear();
  const firstOfMonth = new Date(year, month, 1);
  const daysOffset = firstOfMonth.getDay();
  const day = date.getDate();
  return Math.ceil((day + daysOffset) / 7);
}
__name(getSetPos, "getSetPos");
function getWeekday(date) {
  const weekdays = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
  const weekday = weekdays[date.getDay()];
  return weekday;
}
__name(getWeekday, "getWeekday");
function getWeekNumber(date) {
  const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
  const daysOffset = firstDayOfYear.getDay();
  const diff = (date.getTime() - firstDayOfYear.getTime()) / 864e5;
  return Math.floor((diff + daysOffset + 1) / 7);
}
__name(getWeekNumber, "getWeekNumber");
function getYearDay(date) {
  const startOfYear = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - startOfYear.getTime();
  return Math.floor(diff / 864e5);
}
__name(getYearDay, "getYearDay");
function getReccuringEventInstances(event, instances, from, to) {
  let res = [];
  for (const rule of event.rules ?? []) {
    const values = generateRecurringValues(rule, event.date, from, to);
    for (const val of values) {
      const instance = getInstance(event, val);
      res.push(instance);
    }
  }
  for (const date of event.rdate ?? []) {
    if (date < from || date > to) continue;
    const instance = getInstance(event, date);
    const exists = res.find((p) => p.date === instance.date);
    if (exists === void 0) res.push(instance);
  }
  const excludes = new Set(event.exdate ?? []);
  res = res.filter((p) => !excludes.has(p.date));
  res = res.filter((i) => {
    const override = instances.find((p) => p.originalStartTime === i.originalStartTime);
    return override === void 0;
  });
  return res;
}
__name(getReccuringEventInstances, "getReccuringEventInstances");
function getAllEvents(events, from, to) {
  const base = [];
  const recur = [];
  const instances = [];
  const recurData = [];
  const instancesMap = /* @__PURE__ */ new Map();
  for (const event of events) {
    if (event._class === import__.default.class.ReccuringEvent) {
      recur.push(event);
    } else if (event._class === import__.default.class.ReccuringInstance) {
      const instance = event;
      instances.push(instance);
      const arr = instancesMap.get(instance.recurringEventId) ?? [];
      arr.push(instance);
      instancesMap.set(instance.recurringEventId, arr);
    } else {
      if (from >= event.dueDate) continue;
      if (event.date >= to) continue;
      base.push(event);
    }
  }
  for (const rec of recur) {
    const recEvents = getReccuringEventInstances(rec, instancesMap.get(rec.eventId) ?? [], from, to);
    recurData.push(...recEvents);
  }
  const res = [
    ...base,
    ...recurData,
    ...instances.filter((p) => {
      return from <= p.dueDate && p.date <= to && p.isCancelled !== true;
    })
  ].map((it) => ({ ...it, date: Math.max(from, it.date), dueDate: Math.min(to, it.dueDate) }));
  res.sort((a, b) => a.date - b.date);
  return res;
}
__name(getAllEvents, "getAllEvents");
function generateEventId() {
  const id = (0, import_core.generateId)();
  return encodeToBase32Hex(id);
}
__name(generateEventId, "generateEventId");
function encodeToBase32Hex(input) {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(input);
  const base32HexDigits = "0123456789abcdefghijklmnopqrstuv";
  let result = "";
  for (let i = 0; i < bytes.length; i += 5) {
    const octets = [
      (bytes[i] ?? 0) >> 3,
      (bytes[i] & 7) << 2 | bytes[i + 1] >> 6,
      bytes[i + 1] >> 1 & 31,
      (bytes[i + 1] & 1) << 4 | bytes[i + 2] >> 4,
      (bytes[i + 2] & 15) << 1 | bytes[i + 3] >> 7,
      bytes[i + 3] >> 2 & 31,
      (bytes[i + 3] & 3) << 3 | bytes[i + 4] >> 5,
      bytes[i + 4] & 31
    ];
    for (let j = 0; j < 8; j++) {
      result += base32HexDigits.charAt(octets[j]);
    }
  }
  return result;
}
__name(encodeToBase32Hex, "encodeToBase32Hex");
function getPrimaryCalendar(calendars, preference, acc) {
  if (preference?.attachedTo !== void 0) {
    const pref = calendars.find((p) => p._id === preference.attachedTo && p);
    if (pref !== void 0) return pref._id;
  }
  for (const _calendar of calendars) {
    if (_calendar._class === import__.default.class.ExternalCalendar && !_calendar.hidden && _calendar.default) {
      return _calendar._id;
    }
  }
  return `${acc}_calendar`;
}
__name(getPrimaryCalendar, "getPrimaryCalendar");
//# sourceMappingURL=utils.js.map
